import api from './api';

export const hoursRecordService = {
    async getHours(levelId) {
        try {
            const response = await api.get('/hours-record.php', {
                params: { action: 'get_hours', level_id: levelId }
            });
            return response.data;
        } catch (error) {
            console.error('API Error (Hours Record get_hours):', error);
            throw error;
        }
    },

    async generate(data) {
        try {
            const response = await api.post('/hours-record.php?action=generate', data);
            return response.data;
        } catch (error) {
            console.error('API Error (Hours Record generate):', error);
            throw error;
        }
    },

    getViewUrl(recordId, lang = 'fr') {
        return `${api.defaults.baseURL}/hours-record.php?action=view&record_id=${recordId}&lang=${lang}`;
    },

    async getHistory(levelId) {
        try {
            const response = await api.get('/hours-record.php', {
                params: { action: 'history', level_id: levelId }
            });
            return response.data || [];
        } catch (error) {
            console.error('API Error (Hours Record history):', error);
            return [];
        }
    },

    async getAllHours() {
        try {
            const response = await api.get('/hours-record.php', {
                params: { action: 'get_all_hours' }
            });
            return response.data;
        } catch (error) {
            console.error('API Error (Hours Record get_all_hours):', error);
            throw error;
        }
    },

    getSelfViewUrl(levelVar, lang = 'fr') {
        return `${api.defaults.baseURL}/hours-record.php?action=self_view&level_var=${encodeURIComponent(levelVar)}&lang=${lang}`;
    }
};

export default hoursRecordService;
